import React from 'react';

export const ImagePreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs = {}, specificAttrs = {} } = component;
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: `${specificAttrs?.borderRadius || 0}px`,
    overflow: 'hidden',
    display: 'inline-block'
  };

  const imgStyle = {
    width: '100%',
    height: 'auto',
    objectFit: specificAttrs?.objectFit || 'cover',
    display: 'block'
  };

  return (
    <div style={containerStyle} onClick={onClick}>
      <img 
        src={specificAttrs?.src || 'https://via.placeholder.com/400x300'} 
        alt={specificAttrs?.alt || 'Image'} 
        style={imgStyle}
        loading={specificAttrs?.lazyLoad ? 'lazy' : 'eager'}
      />
    </div>
  );
};
